"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAssignSemigroup = void 0;
/**
 * @since 2.10.0
 */
var Semigroup_1 = require("./Semigroup");
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * Return a semigroup which works like `Object.assign`.
 *
 * @example
 * import { getAssignSemigroup } from 'fp-ts/struct'
 *
 * interface Person {
 *   readonly name: string
 *   readonly age: number
 * }
 *
 * const S = getAssignSemigroup<Person>()
 * assert.deepStrictEqual(S.concat({ name: 'name', age: 23 }, { name: 'name', age: 24 }), { name: 'name', age: 24 })
 *
 * @category instances
 * @since 2.10.0
 */
// tslint:disable-next-line: deprecation
exports.getAssignSemigroup = Semigroup_1.getObjectSemigroup;
